export enum SectionEnum {
  ADMIN = 'admin',
  CONTACT = 'contact',
  DEVELOPER = 'developer',
  GENERAL = 'general',
  SYSTEM = 'system',
  TRANS_EMAIL = 'trans_email',
  WEB = 'web',
}